import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DepartmentActions } from './department.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { DepartmentService } from '@core/services/department.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DepartmentEffects {
  private actions$ = inject(Actions);
  private departmentService = inject(DepartmentService);
  private translateService = inject(TranslateService);
  getdepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentActions.loadDepartments),
      mergeMap((data) =>
        this.departmentService.getDepartments(data).pipe(
          map((departments) =>
            departments.success
              ? DepartmentActions.loadDepartmentsSuccess(departments)
              : DepartmentActions.loadDepartmentsFailure(departments)
          ),
          catchError((error) =>
            of(
              DepartmentActions.loadDepartmentsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addDepartment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentActions.addEditDepartment),
      mergeMap((data) =>
        this.departmentService.addDepartment(data).pipe(
          map((department) => {
            if (department.success)
              return data.id
                ? DepartmentActions.updateDepartmentSuccess(department)
                : DepartmentActions.addDepartmentSuccess(department);
            else return DepartmentActions.addDepartmentFailure(department);
          }),
          catchError((error) =>
            of(
              DepartmentActions.addDepartmentFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DepartmentActions.deleteDepartment),
      mergeMap((data) =>
        this.departmentService.deleteDepartment(data.id).pipe(
          map((response: any) =>
            response.body.success
              ? DepartmentActions.deleteDepartmentSuccess({
                  ...response.body,
                  id: data.id,
                })
              : DepartmentActions.deleteDepartmentFailure(response.body)
          ),
          catchError((error) =>
            of(
              DepartmentActions.deleteDepartmentFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
